export default __webpack_public_path__ + "static/media/ico-note.cbfffdae.svg";